import React from 'react';
import giraClient from '@atlassian/jira-apollo-gira';
import { ApolloClientProvider } from '@atlassian/jira-apollo-multiple-clients/src/main.tsx';
import AppBase from '@atlassian/jira-app-base';
import ApdexProvider from '@atlassian/jira-providers-spa-apdex-analytics/src/provider.tsx';
import SetCustomMark from '@atlassian/jira-providers-spa-apdex-analytics/src/set-custom-mark/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { TIME_TO_LOAD_MARK_KEY } from './common/constants';
import { AccessPageProvider } from './services/access-page-context';
import type { Props } from './types';
import UsersAndRolesDumb from './ui';

/**
 * This check is is being performed for simplified project as well as for next gen projects
 * that are being accessed via the old url. this is a temporary fix as the old url should
 * redirect. this is to allow apdex to be re-activated on this page.
 */
const shouldRenderApdexProvider = (props: Props): boolean =>
	props.isProjectSimplified || window.location.href.indexOf('/plugins/servlet/project-config/') > 0;

const renderApp = (props: Props) => {
	const { renderDetailsLink, showBreadcrumbs, locale, isProjectSimplified, ...restProps } = props;
	return (
		<ApolloClientProvider client={giraClient}>
			<AppBase id="actors-and-roles">
				<AccessPageProvider
					context={{
						...restProps,
						locale,
						isProjectSimplified,
					}}
				>
					<UsersAndRolesDumb
						renderDetailsLink={renderDetailsLink}
						showBreadcrumbs={showBreadcrumbs}
					/>
				</AccessPageProvider>
				<SetCustomMark name={TIME_TO_LOAD_MARK_KEY} />
			</AppBase>
		</ApolloClientProvider>
	);
};

const UsersAndRolesApp = (props: Props) => {
	const app = renderApp(props);
	return (
		<UFOSegment name="users-and-roles-app">
			{shouldRenderApdexProvider(props) ? (
				<ApdexProvider pageId="project-settings-people">{app}</ApdexProvider>
			) : (
				app
			)}
		</UFOSegment>
	);
};
UsersAndRolesApp.defaultProps = {
	showBreadcrumbs: false,
};

export default UsersAndRolesApp;
